var map = {
	"./logo-alphabet.svg": 2344,
	"./logo-amazon-2.svg": 2345,
	"./logo-amazon.svg": 2346,
	"./logo-azercell.svg": 2347,
	"./logo-bank-of-america.svg": 2348,
	"./logo-barclays.svg": 2349,
	"./logo-bnp-paribas.svg": 2350,
	"./logo-booking.svg": 2351,
	"./logo-citibank.svg": 2352,
	"./logo-coca-cola.svg": 2353,
	"./logo-deloitte.svg": 2354,
	"./logo-experian.svg": 2355,
	"./logo-facebook.svg": 2356,
	"./logo-goldman-sachs.svg": 2357,
	"./logo-google.svg": 2358,
	"./logo-h.svg": 2359,
	"./logo-infineon.svg": 2360,
	"./logo-instagram.svg": 2361,
	"./logo-jp-morgan.svg": 2362,
	"./logo-jti.svg": 2363,
	"./logo-linkedin.svg": 2364,
	"./logo-meta.svg": 2365,
	"./logo-oracle.svg": 2366,
	"./logo-paypal.svg": 2367,
	"./logo-pwc.svg": 2368,
	"./logo-tesla.svg": 2369,
	"./logo-visa.svg": 2370,
	"./logo-walmart.svg": 2371,
	"./logo-youtube.svg": 2372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2343;